<template>
  <div>
    <jt-data-table
      ref="jtDataTable"
      :api-mode="false"
      :data="invoices"
      :fields="columns"
      :is-paginated="false"
      :title="$gettext('SLECTED_INVOICES')"
    >
      <template #header="{ props }">
        <q-tr :props="props" class="table-header">
          <q-td v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-td>
          <q-td style="width: 5px"> </q-td>
        </q-tr>
      </template>
      <template #body="{ props }">
        <q-tr class="text-left">
          <q-td
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
            style="color: #333"
          >
            <div v-if="col.field == 'ref'">
              <strong style="font-size: 14px">
                {{ getInvoiceMonthOrReference(props.row) }}
              </strong>
              <br />
              <span>
                {{ props.row["ano"] }}
              </span>
            </div>
            <span
              v-else-if="
                col.field == 'vencimentoAtual' || col.field == 'dtvencto'
              "
            >
              <span class="tw-flex tw-justify-center" style="font-size: 17px">
                {{ props.row["dtvencto"] }}
                <div v-if="extensionDateDay">
                  <strong class="tw-bg-amber-300">
                    {{ updateDateWithNewDay(props.row["dtvencto"]) }}
                  </strong>
                </div>
              </span>
            </span>
            <span v-else-if="col.field == 'valor'" class="cell-values">
              <span style="font-size: 17px">
                {{ $toLocaleStringBr(col.value) }}
              </span>
              <span style="font-size: 12px" v-if="props.row.dtvenctoOriginal">
                {{ $gettext("MATURITY") }}
                {{ props.row.dtvenctoOriginal }}
              </span>
            </span>
          </q-td>
          <q-td>
            <q-btn
              @click="
                () => {
                  removeInvoice(props.row);
                }
              "
              flat
            >
              <q-icon name="mdi-trash-can-outline" size="20px" />
            </q-btn>
          </q-td>
        </q-tr>
      </template>
    </jt-data-table>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtInput, JtSelect } from 'jtech-webcomps'
import NegotiationController from '../NegotiationController'
import ServiceRequestController from 'src/modules/concession/service-request/ServiceRequestController'
import { QCheckbox } from 'quasar'
import { getInvoiceMonthOrReference } from 'src/shared/global/UtilInvoice'
import moment from 'moment'
@Component({
  name: 'InvoiceSelectedSteep',
  components: {
    JtDataTable,
    JtInput,
    QCheckbox,
    JtSelect
  },
  props: {
    consumerUnit: String,
    protocol: String,
    extensionDateDay: {
      type: String,
      default: null
    },
    isHideDebts: {
      type: Boolean,
      default: false
    }
  }
})
class InvoiceSelectedSteep extends Vue {
  controller = ServiceRequestController.getInstance();
  negotiationController = NegotiationController.getInstance();
  getInvoiceMonthOrReference = getInvoiceMonthOrReference;
  moment = moment;
  columns = [
    {
      name: 'ref',
      label: this.$gettext('REF'),
      align: 'center',
      value: 'ref',
      field: 'ref'
    },
    {
      name: 'valor',
      align: 'center',
      label: this.$gettext('ORIGINAL_MATURITY_VALUE'),
      value: 'valor',
      field: 'valor'
    },
    {
      name: 'vencimentoAtual',
      align: 'center',
      label: this.$gettext('CURRENT_DUE_DATE'),
      value: 'vencimentoAtual',
      field: 'vencimentoAtual'
    }
  ];

  baseColumns () {
    return this.columns.filter((column) => {
      if (
        this.isHideDebts &&
        ['newValue', 'feelsValue', 'fineValue'].includes(column.field)
      ) {
        return false
      }
      return true
    })
  }

  updateDateWithNewDay (dateString) {
    if (!this.extensionDateDay) return dateString
    const date = moment(dateString, 'DD/MM/YYYY')
    date.date(parseInt(this.extensionDateDay))
    return date.format('DD/MM/YYYY')
  }

  get invoices () {
    return this.negotiationController.getInvoices()
  }

  removeInvoice (row) {
    const updatedInvoices = this.negotiationController
      .getInvoices()
      .filter((i) => i.id !== row.id)
    this.negotiationController.setInvoices(updatedInvoices)
    if (updatedInvoices.length === 0) {
      this.$emit('hideModal')
    }
  }
}

export default InvoiceSelectedSteep
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
